class RecentlyViewedProducts extends HTMLElement {
  /**
   * @type {Array} handles - An array of recently viewed product handles.
   */
  handles = this.getViewedProducts();

  connectedCallback() {
    this.renderBasedOnHandles();
  }

  /**
   * @description Retrieves the list of recently viewed products from local storage.
   * @returns {Array} An array of product handles that have been recently viewed.
   */
  getViewedProducts() {
    return JSON.parse(localStorage.getItem('viewedProducts') || '[]');
  }

  /**
   * @description Render based on the localStorage handles.
   */
  async renderBasedOnHandles() {
    // If there are no handles, remove the element from the DOM.
    if (!this.handles.length) return this.remove();

    // Fetch the product card for each handle.
    let htmlCardArray = await Promise.all(
      this.handles.map(async (handle) => {
        const card = await this.fetchProductCard(handle);
        return card;
      })
    );

    // Add the cards to the swiper-wrapper.
    this.querySelector('.swiper-wrapper').innerHTML = htmlCardArray.join('');
  }

  /**
   * Fetches the HTML content of a product card for a given product handle.
   * @param {string} handle - The handle of the product to fetch.
   * @returns {Promise<string>} The HTML content of the product card.
   */
  async fetchProductCard(handle) {
    try {
      const response = await fetch(`/products/${handle}?section_id=recently-viewed-product-card`);
      const html = await response.text();
      const parsedElement = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.shopify-section')?.innerHTML;
      return parsedElement;
    } catch (error) {
      console.warn(`Error fetching product card ${handle}`);
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
